import { Box, Flex } from "@radix-ui/themes";
import { useState } from "react";
import type { ReactNode } from "react";
import { useIsDesktop } from "@/hooks/use-media-query";
import { MobileNavPanel } from "./mobile-nav-panel";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const isDesktop = useIsDesktop();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <Flex
      style={{
        minHeight: "100vh",
        width: "100%",
      }}
    >
      {isDesktop ? <Sidebar /> : <MobileNavPanel open={mobileNavOpen} onOpenChange={setMobileNavOpen} />}

      <Flex direction="column" flexGrow="1" style={{ minWidth: 0 }}>
        <Topbar onMenuClick={() => setMobileNavOpen(true)} showMenuButton={!isDesktop} />
        <Box asChild p={{ initial: "3", sm: "5" }} flexGrow="1">
          <main>{children}</main>
        </Box>
      </Flex>
    </Flex>
  );
}
